/** Alat tone analis: sel tone yang bisa diedit inline + bilah aksi massal. */
const OPT = [["positive", "Positif"], ["neutral", "Netral"], ["negative", "Negatif"]] as const;
const C: Record<string, string> = { positive: "var(--sent-pos)", neutral: "var(--sent-neu)", negative: "var(--sent-neg)" };

export function ToneCell({ id, value, provenance, onSaved }: { id: string; value: string | null; provenance?: string | null; onSaved: (v: string) => void }) {
  return (
    <span onClick={(e) => e.stopPropagation()} title={provenance === "human_override" ? "Tone hasil koreksi analis (kebal timpa sync)" : "Tone vendor — klik utk koreksi"}>
      <select value={value ?? ""} onChange={async (e) => {
          const v = e.target.value; if (!v) return;
          const r = await fetch(`/api/v1/mentions/${id}/tone`, { method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ sentimentLabel: v }) });
          if (r.ok) onSaved(v);
          else alert(r.status === 403 ? "Role Anda tidak berhak mengoreksi sentimen." : `Gagal menyimpan tone (HTTP ${r.status}).`);
        }}
        style={{ border: "1px solid " + (C[value ?? ""] ?? "var(--color-border-strong)"), color: C[value ?? ""] ?? "var(--color-text-secondary)", borderRadius: "var(--radius-xs)", padding: "2px var(--space-3)", background: "var(--color-surface)", fontSize: "var(--text-sm)", cursor: "pointer" }}>
        <option value="">—</option>
        {OPT.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
      </select>
      {provenance === "human_override" && <i className="fa-solid fa-user-pen" title="Koreksi analis" style={{ marginLeft: "var(--space-2)", fontSize: 10.5, color: "var(--cat-4)" }} />}
    </span>
  );
}

export function BulkToneBar({ selected, onDone, onClear }: { selected: string[]; onDone: () => void; onClear: () => void }) {
  if (selected.length === 0) return null;
  async function apply(v: string) {
    const r = await fetch("/api/v1/mentions/bulk-tone", { method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ ids: selected, sentimentLabel: v }) });
    if (r.ok) onDone();
    else alert(r.status === 403 ? "Role Anda tidak berhak mengoreksi sentimen." : `Gagal menyimpan tone massal (HTTP ${r.status}).`);
  }
  return (
    <div style={{ display: "flex", gap: "var(--space-6)", alignItems: "center", background: "var(--brand-800)", color: "#fff", borderRadius: "var(--radius-md)", padding: "var(--space-5) var(--space-6)", margin: "var(--space-5) 0" }}>
      <b><i className="fa-solid fa-square-check" /> {selected.length} terpilih</b>
      <span style={{ opacity: 0.75 }}>ubah tone menjadi:</span>
      {OPT.map(([v, l]) => (
        <button key={v} className="avio-chip" data-sentiment={v} onClick={() => apply(v)} style={{ cursor: "pointer", border: 0, fontWeight: "var(--weight-semi)" as any }}>{l}</button>
      ))}
      <button className="avio-btn" data-variant="ghost" data-size="sm" onClick={onClear} style={{ marginLeft: "auto", color: "#fff" }}>✕ batal</button>
    </div>
  );
}
